import { Button, Tooltip } from "antd";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { ReactComponent as PlusRoundIcon } from "images/plus-round.svg";
import { AddUserModal } from "./AddUserModal";
import { CustomButton } from "ui";

export const AddUserButton = observer(({ isIconButton = false }: { isIconButton?: boolean }) => {
  const { actionModals } = useStores();

  const openAddUserModalHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    actionModals.open(() => <AddUserModal />, {
      width: "600px",
      noValidation: true,
      title: "Выберите пользователя",
      isOverlayClose: false,
      onApply: () => {
        return Promise.resolve();
      },
    });
  };
  return isIconButton ? (
    <Tooltip title="Добавить пользователя">
      <Button type="link" size="small" icon={<PlusRoundIcon />} onClick={openAddUserModalHandler} />
    </Tooltip>
  ) : (
    <CustomButton onClick={openAddUserModalHandler}>Добавить пользователя</CustomButton>
  );
});
